import React from "react";
import SEO from "../SEO";
import Navbar from "../Navbar";
import PageFooter from "../PageFooter";
import BlogIndex from "../BlogIndex";
import WindowSizeContext from "../../contexts/windowSizeContext";
import useWindowSize from "../../hooks/useWindowSize";
import IpGeoDataContext from "../../contexts/ipGeoDataContext";
import useIpGeoData from "../../hooks/useIpGeoData";
import useHasMounted from "../../hooks/useHasMounted";
import UnavailableLocation from "../UnavailableLocation";
import { shouldBlockUserBasedOn } from "../../services/GeoLocationService";

/**
 * The default layout component for MDX rendered Blog pages.
 *
 * This layout page sets the WindowSizeContext from the useWindowSize hook.
 *
 * @param {Props} props Array of data passed to the function from the parent component and the rendering pipeline.
 * @returns (element) A layout page, configured with the meta data passed, which renders the child elements passed.
 */
export default (props) => {
  const { pageMetaData, children } = props;
  const { pageTitle, pageDescription, pageStrapLine, pageImagePath, pageMetaTags } = pageMetaData;
  const windowSize = useWindowSize();
  const ipGeoData = useIpGeoData();
  const hasMounted = useHasMounted();

  if (ipGeoData.isLoading === true || !hasMounted) {
    return (
      <>
        <SEO title={pageTitle} description={pageDescription} strapLine={pageStrapLine} pageImagePath={pageImagePath} meta={pageMetaTags} />
      </>
    );
  }

  if (shouldBlockUserBasedOn(ipGeoData)) {
    return <UnavailableLocation ipGeoData={ipGeoData} windowSize={windowSize.windowSize} />;
  }

  return (
    <WindowSizeContext.Provider value={windowSize}>
      <IpGeoDataContext.Provider value={ipGeoData}>
        <div className="flex flex-col min-h-screen border border-transparent font-body">
          <SEO title={pageTitle} description={pageDescription} strapLine={pageStrapLine} pageImagePath={pageImagePath} meta={pageMetaTags} isBlogPost={true} />
          <header>
            <Navbar />
          </header>
          <main className="content">
            <div className="container mx-auto">
              <BlogIndex content={children} />
            </div>
          </main>
          <footer>
            <PageFooter />
          </footer>
        </div>
      </IpGeoDataContext.Provider>
    </WindowSizeContext.Provider>
  );
};
